import React, { useState } from "react";
import Constants from "../../constants/constants";
import { LogOut, RefreshState } from "../../functions/index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
function SelectApi(props) {
  const [show, setShow] = useState(false);
  const toggleBaseAPi = async () => {
    props.setApi(!props.api);
  };
  return (
    <div className={show ? "devEnvironment" : "devEnvironment roll-up"}>
      {show && (
        <>
          <span>{Constants.DevEnvironmentText}</span>
          <BootstrapSwitchButton
            checked={props.api}
            onlabel={Constants.DevEnvironmentTextLabelAgree}
            onstyle="no"
            offlabel={Constants.DevEnvironmentTextLabelNotAgree}
            offstyle="yes"
            onChange={() => {
              toggleBaseAPi();
              LogOut();
              RefreshState();
            }}
          />
        </>
      )}

      <span className="close" onClick={() => setShow(!show)}>
        {show ? (
          <FontAwesomeIcon icon={faChevronUp} />
        ) : (
          <FontAwesomeIcon icon={faChevronDown} />
        )}
      </span>
    </div>
  );
}
export default SelectApi;
